import { Component, NgZone, OnInit } from '@angular/core';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { MemoryService } from './memory.service';
import { WebVitalsService } from './web-vitals.service';

@Component({
    selector: 'ohp-web-vitals',
    templateUrl: './web-vitals.component.html'
})
export class WebVitalsComponent implements OnInit {

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly memoryService: MemoryService,
        private readonly ngZone: NgZone,
        private readonly webVitalsService: WebVitalsService
    ) {
    }

    public ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            if (this.capabilitiesService.capabilities.webVitalsEnabled) {
                this.webVitalsService.getVitalsAndTTVR();
            }
            if (this.capabilitiesService.capabilities.memoryProfilingEnabled) {
                this.memoryService.getMemoryProfile();
            }
        });
    }

}
